import './SharedChannelsCards.css';
import React, { memo } from 'react';
import { isNotNil } from '../../../utils/IsNil';
import RouterLink from '../RouterLink';
import { ReactComponent as IconRightChevron } from '../../../resources/icons/sharedChannelRightChevron.svg';
const SharedChannelCards = /*#__PURE__*/memo(_ref => {
  let {
    hit,
    rtl,
    className,
    BASE_URL
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: `${className} ${commonStyles} ${rtl ? rtlStyles : ltrStyles}`,
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "cardWrapper"
  }, /*#__PURE__*/React.createElement(RouterLink, {
    href: hit.ctaLink ? hit.ctaLink : "#"
  }, /*#__PURE__*/React.createElement("div", {
    className: "iconCircle"
  }, isNotNil(hit.mediasvgcode) && hit.mediasvgcode.includes("svg") ? /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: hit.mediasvgcode
    },
    className: "h__icon"
  }) : /*#__PURE__*/React.createElement("img", {
    className: "h__icon",
    src: BASE_URL + hit.mediaUrl,
    alt: ""
  }))), hit.title ? /*#__PURE__*/React.createElement(RouterLink, {
    href: hit.ctaLink ? hit.ctaLink : "#"
  }, /*#__PURE__*/React.createElement("p", {
    className: "cardTitle"
  }, hit.title)) : null, hit.description ? /*#__PURE__*/React.createElement("div", {
    className: "cardDescription"
  }, hit.description) : null, /*#__PURE__*/React.createElement("div", {
    className: "c--link-more"
  }, /*#__PURE__*/React.createElement(RouterLink, {
    href: hit.ctaLink ? hit.ctaLink : "#"
  }, /*#__PURE__*/React.createElement(IconRightChevron, {
    className: "chevronIcon"
  })))));
});
const commonStyles = "c1xuisfp";
const ltrStyles = "l1v8y5me";
const rtlStyles = "r1gv6sgm";
export { SharedChannelCards };